import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

import DocumentsCard from './Documents/DocumentsCard';

import './ProductDocuments.scss';

class ProductDocuments extends React.PureComponent {
  render() {
    const { product, strings } = this.props;

    const handleRoute = ({ url }) => {
      const { onRoute } = this.props;
      onRoute({ url });
    };

    return (
      <>
        <div className="block-toggle-view documents">
          <div className="header">
            <div className="title">Documents</div>
          </div>
          <div className="content">
            {product && product.code ? (
              <DocumentsCard
                id={`documents-${product.code}`}
                data={get(product, 'public_documents', [])}
                strings={strings}
                handleRoute={handleRoute}
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      </>
    );
  }
}

ProductDocuments.propTypes = {
  product: PropTypes.object, // eslint-disable-line
  strings: PropTypes.objectOf(PropTypes.string),
  loading: PropTypes.object, // eslint-disable-line
  onRoute: PropTypes.func,
};

ProductDocuments.defaultProps = {
  product: {},
  strings: {},
  loading: {},
  onRoute: val => {
    console.log('onRoute::', val); /* eslint-disable-line no-console */
  },
};

export default ProductDocuments;
